var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 .868c-1.65 0-3 1.35-3 3 0 .496.191 1.002.438 1.562.26.583.552 1.152.875 1.703.4.688.828 1.36 1.281 2.016L9 9.742l.406-.595s.645-.917 1.281-2.014c.323-.552.615-1.12.876-1.704.245-.56.437-1.066.437-1.562 0-1.65-1.35-3-3-3Zm-5.015.969L0 3.538v9.593L4.016 11.4l4 1.5L12 11.194V6.836c-.31.586-.644 1.16-1 1.719v1.984l-2.5 1.063v-.813l-.734-1.063a35.45 35.45 0 0 1-.266-.39v2.312l-3-1.125V3.087l.547.203c.047-.333.136-.659.266-.969l-1.328-.485ZM9 1.867c1.11 0 2 .891 2 2 0 .194-.121.65-.344 1.157a17.33 17.33 0 0 1-.844 1.609c-.407.703-.583.953-.812 1.297-.229-.344-.405-.594-.813-1.297a17.403 17.403 0 0 1-.843-1.61C7.12 4.52 7 4.062 7 3.869c0-1.11.89-2 2-2Zm-5.5 1.25v7.423L1 11.601V4.195l2.5-1.078Zm5.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.491285823d36d24e785d75e1290d57c3.svg";
export { ForwardRef as ReactComponent };